<template>
    <div class="div">
        <el-form :inline="true" :model="params" class="demo-form-inline" size="mini" label-width="100px">
            <el-form-item label="字典类型">
                <el-input v-model="params.name" clearable placeholder="请输入字典类型"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button plain  @click="getData">查询</el-button>
                <el-button plain type="primary" @click="addDic">增加</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="dicTypeList" style="width: 100%" size="mini" height="calc(100vh - 134px)">
            <el-table-column type="index" label="序号" width="300"></el-table-column>
            <el-table-column prop="typeName" label="字典类型" width="auto" > </el-table-column>
            <el-table-column/>
        </el-table>
        <!-- 新增字典类型 -->
        <el-dialog v-dialogDrag title="新增字典类型" :visible.sync="addDicShow"  width="40%" :before-close="cancel">
            <el-input v-model="addDicType.name" placeholder="请输入字典类型"></el-input>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sure">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
    data() {
        return {
            params:{
                name:""
            },
            dicTypeList:[],
            addDicShow:false,
            addDicType:{
                name:"",
            },
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        // 查询字典类型
        getData(){
            this.$api.getDicTypeList( this.params ).then(res =>{
                this.dicTypeList = res
            })
        },
        // 增加字典类型
        addDic(){
            this.addDicShow = true
        },
        // 取消新增
        cancel(){
            this.addDicShow = false
            this.addDicType.name === ''
        },
        // 确定新增
        sure(){
            if(this.addDicType.name === ''){
                this.$message.error('请输入字典类型！')
            }else{
                this.$api.addDicType(this.addDicType.name).then(res =>{
                    this.$message({
                        message: '新增成功',
                        type: 'success'
                    });
                    this.cancel()
                    this.getData()
                })
            }
        },
    }
}
</script>
<style lang="css" scoped>
.div{
    background-color: white;
    padding: 10px;
}
.el-table {
    margin-top: 0px;
}
.el-form-item {
    margin-bottom: 0px !important;
}
</style>